<template>
  <form-section :title="$t('Profiles_Overview_Title_RecentMessages')">
    <rest-list
      :payload="fetchEndpoint"
      :border="false"
      :outline="false"
      :filterable="false"
      :pagination="false"
    >
      <rest-list-column-date
        prop="create_time"
        title="Date"
        :width="180"
        :sortable="false"
      />

      <rest-list-column-enum
        prop="message_type"
        title="Type"
        :enum="MessageTypeLabel"
        :width="110"
        :sortable="false"
      />

      <rest-list-column
        prop="campaign_title"
        title="Campaign"
        :sortable="false"
      />

      <rest-list-column
        prop="status"
        title="Status"
        :width="100"
        :sortable="false"
        align="center"
      >
        <template slot-scope="{ row }">
          <el-tag :type="statusTagType(row)" size="small">
            {{ statusTagLabel(row) }}
          </el-tag>
        </template>
      </rest-list-column>
    </rest-list>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import { projectEndpoint } from '@/core/helpers'
import RestList from '@/common/components/rest/RestList'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import { MessageTypeLabel } from '@/common/enum/MessageTypeEnum'
import { MessageDeliveryStatusEnum } from '@/common/enum/MessageDeliveryStatusEnum'

export default {
  name: 'RecentMessages',

  components: {
    RestListColumnEnum,
    RestListColumn,
    RestListColumnDate,
    RestList,
    FormSection
  },

  data() {
    return {
      MessageTypeLabel
    }
  },

  props: {
    profileId: {
      type: String,
      required: true
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `profiles/${this.profileId}/messages`,
        params: {
          expand: 'campaign_title',
          sort: '-create_time',
          'per-page': 3
        }
      })
    }
  },

  methods: {
    statusTagType(row) {
      if (row.error) {
        return 'danger'
      } else if (row.click > 0 || row.open > 0) {
        return 'success'
      } else {
        return 'info'
      }
    },

    statusTagLabel(row) {
      if (row.delivery_status === MessageDeliveryStatusEnum.CONTROL_GROUP) {
        return 'Control Group'
      } else if (row.delivery_status === MessageDeliveryStatusEnum.FAILED) {
        return 'Failed'
      } else if (row.delivery_status === MessageDeliveryStatusEnum.BOUNCED) {
        return 'Bounced'
      } else if (row.click > 0) {
        return 'Clicked'
      } else if (row.open > 0) {
        return 'Opened'
      } else if (row.delivery_status === MessageDeliveryStatusEnum.DELIVERED) {
        return 'Delivered'
      } else if (row.delivery_status === MessageDeliveryStatusEnum.SENT) {
        return 'Sent'
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>
>>> th {
  color: #acb0b5;
  font-size: 12px;
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/LatestMessages.vue